import { PaymentMethod } from '@prisma/client';
import { convertSnakeToTitleCase } from './global';

export function getPaymentMethodText(paymentMethod: PaymentMethod) {
  const displayPaymentMethod =
    paymentMethod === 'TERMINAL' ? 'CREDIT' : paymentMethod;
  return convertSnakeToTitleCase(displayPaymentMethod);
}
